<template>
  <div class="header-container is-flex print-bg" :class="{'edit-view': showAdminToolbar}">
    <admin-toolbar v-if="showAdminToolbar" :showAdminToolbar="showAdminToolbar"></admin-toolbar>
    <publish-toolbar v-if="showAdminToolbar" :project="project" :isView="true" @save="toggleConfirmPublishModal"></publish-toolbar>

    <nav class="breadcrumb is-left is-flex cursor-pointer no-print" :class="{'admin-breadcrumb': showAdminToolbar}">
      <ul class="is-flex has-text-weight-semibold gtm-story-home-breadcrumb no-print" @click="$router.go(-1)">
        <span class="icon is-small is-flex gtm-story-home-breadcrumb"><i class="fal fa-chevron-left"></i></span>
        <li><span class="breadcrumb-item gtm-story-home-breadcrumb">BACK</span></li>
      </ul>
    </nav>
    <div class="project-header is-flex neweng-print-bg" :class="{'project-header-padding':showAdminToolbar, 'project-header-quickread':hasQuickRead}">

      <div class="header-content is-flex neweng-print-bg ">
        <div class="header-right is-flex">
          <!-- Resource title-->
          <h1 v-if="isResource" class="resource-title">{{resourceTitle}}</h1>
          <!-- Project Title -->
          <h2 class="title is-2 is-size-3-mobile is-marginless has-text-weight-bold has-text-centered">{{this.project.title}}</h2>
          <h4 class="resource-date" v-if="resourceType === 'webinar'"> {{webinarDate}} </h4>
          <!-- Project Description -->
          <div v-if="seenDescription && resourceType !== 'webinar'" class="project-description is-size-4 is-size-6-mobile has-text-centered">
            <markdown-span :isHeader="true" :content="project.description"></markdown-span>
          </div>
          <span v-if="hasResource">
            <div v-if="showEmbeddedVideo" v-html="project.resource.video_embed">
            </div>
            <img v-else class="resource-image" :src="this.project.imageUrl">
          </span>
          <!-- Project Meta -->
          <div v-if="!hasResource" class="project-meta is-flex" :class="{'no-description': !seenDescription}">

            <!-- Project Creator -->
            <div class="project-creator is-flex gtm-proj-creator">
              <div class="creator">
                <div class="meta-title">{{ $t('story-header.written') }}</div>
                <div @click="viewProfile(username)" class="owner is-flex gtm-proj-creator cursor-pointer">
                  <div class="owner-icon gtm-proj-creator"><img :src="avatar" :alt="username"></div>
                  <div class="owner-name is-size-7 has-text-weight-semibold gtm-proj-creator">
                    {{ fullname.replace(/^\s+|\s+$/gm,'') }}<span v-if="project.user.isEngStaff" class="staff-shield"><i class="fal fa-shield-check"></i></span>
                    </div>
                </div>
              </div>
            </div>
            <!-- Meta Counts -->
            <meta-counts v-if="!isPrivate" class="meta-counts" :project="this.project" :post="this.post"></meta-counts>
            <div ref="audioContainer" class="audio-container no-print">
              <div :class="{'fixed-position' : isAudioFix}">
                <div :class="{'audio-background no-print' : isAudioFix}">
                  <div class="audio-player cursor-pointer is-flex a gtm-audio-play" @click="showAudioPlayer" v-if="!audioPlayer">
                    <span class="dot audio-player is-flex" v-if="audioExists"><i class="fal fa-play is-size-7 play-button gtm-audio-play"></i></span>
                    <p class="listen-txt-btn meta-title has-text-weight-bold no-print" v-if="audioExists">{{ $t('story-header.listen') }}</p>
                  </div>
                  <audio controls v-if="audioPlayer && audioExists" :class="{ 'edge-audio-btn': isIEEdge }" id="audioButton" >
                    <source :src="this.project.article.audioURL" type="audio/mpeg">
                    Your browser does not support the audio tag!
                  </audio>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <social-media :project="project" :post="post" ></social-media>
    </div>
  </div>
</template>

<script>
import AdminToolbar from './AdminToolbar'
import MetaCounts from './MetaCounts'
import Team from './Teams'
import SocialMedia from './SocialMedia'

import Report from '@/components/UIReport'
import MarkdownSpan from '@/components/Controls/MarkdownSpan'
import PublishToolbar from '@/components/Controls/PublishToolbar'
import ResourceCta from '@/components/Forms/ResourceCta'

import userAgent from '@/libs/user-agent'

import mixin from './header'
import i18n from '@/i18n'
import resources from '@/mixins/resources'
import features from '@/mixins/features'

export default {
  components: {
    AdminToolbar,
    Team,
    SocialMedia,
    MetaCounts,
    MarkdownSpan,
    Report,
    PublishToolbar,
    ResourceCta
  },

  mixins: [mixin, resources, features],

  props: ['hasQuickRead'],
  created: function () {
    this.featureGroupName = 'Project View'
    this.getFeatures()
  },
  data: function () {
    return {
      isAudioFix: false,
      audioPlayer: false,
      isMounted: false,
      newest: ''
    }
  },
  computed: {
    todayInEngineeringHack: function () {
      return this.project && this.project.user && this.project.tags && this.project.user.userName === 'engineering.com' && this.project.tags.length === 1 && this.project.tags[0].name.toLowerCase() === 'videos'
    },
    user: function () {
      return this.post ? this.post.user || {} : {}
    },
    isCreator: function () {
      return this.isLoggedIn ? this.user.uuid === this.currentUser.uuid : false
    },
    audioExists: function () {
      return this.project.article && this.project.article.audioURL
    },
    isIEEdge: function () {
      return userAgent.isEdge() || userAgent.isIE11()
    },
    audioSize: function () {
      if (this.isMounted) {
        return {
          width: `${this.$refs.audioContainer.clientWidth}px`,
          height: `${this.$refs.audioContainer.clientHeight}px`
        }
      }
    },
    post: function () {
      return this.posts[0]
    },
    resourceTitle: function () {
      let jsonKey = 'resource.story'
      if (this.hasResource) {
        jsonKey = 'resource.' + this.resourceType.replace(/\s+/g, '')
      }
      return i18n.t(jsonKey)
    },
    isResource: function () {
      return this.project.resource.id > 0
    },
    showAdminToolbar: function () {
      return this.hasFeature('adminToolbar')
    }
  },

  mounted: function () {
    this.modals = [this.$refs.loginModal]
    this.isMounted = true
    window.addEventListener('scroll', this.shouldFixAudio)
    if (this.$route.query.newest) {
      this.newest = true
    }
    this.checkWebinarRegistration()
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.shouldFixAudio)
  },

  methods: {
    showAudioPlayer: function () {
      this.audioPlayer = true
      this.$nextTick(() => {
        document.getElementById('audioButton').play()
      })
    },
    shouldFixAudio: function () {
      if (this.$refs.audioContainer) {
        const rect = this.$refs.audioContainer.getBoundingClientRect()
        this.isAudioFix = rect.top < 52
      }
    },
    checkWebinarRegistration: function () {
      if (!this.isLoggedIn || !this.project.resource.id) {
        return
      }
      this.$store.dispatch('checkWebinarRegistration', this.project.resource.id)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  #audioButton {
    @include mobile {
      width: 182px;
    }
  }
.header-container {
  max-width: 700px; // controls the width of all components
  margin: 0 auto;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: #F8F8F8;
    padding: 0;
    position: static;
    border-top: 0.5rem solid whitesmoke;
  }
  .edit-view {
    border-top: none;
  }
  .project-header {
    position: relative;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    padding: 0rem 3.7rem;
    background-color: #F8F8F8;
    @include mobile {
      padding: 0 0.5rem 1rem;
      max-width: 100%;
    }
  }
  .project-header-quickread {
    border-bottom: 0.5rem solid whitesmoke;
  }
  .project-header-padding {
    padding: 1.5rem 3rem 2.5rem;
  }
  .project-meta {
    width: 100%;
    max-width: 100%;
    position: relative;
    margin-top: 1rem;
    margin-bottom:1rem;
    align-items: center;
    &.no-description {
      margin-top: 1.5rem;
    }
    @include mobile {
      left: 0;
      max-width: 100%;
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  .creator {
    margin-right: 1rem;
  }

  .creator .meta-title{
    margin-top: 0.5rem;
    @include mobile {
      text-align: center;
    }
    @include mini-mobile {
      margin-top: 0;
      font-size: 0.65rem;
    }
  }
  .header-content {
    align-items: flex-start;
    padding-right: 0.5rem;
    width: 100%;
    height: 100%;
    @include mobile {
      padding-right: 0;
    }
  }
  .cover-photo-container {
    width: 100%;
  }
  .cover-photo {
    min-height: 40vh;
    width: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    @include mobile {
      min-height: 28vh;
    }
    &.position-bottom {
      background-position: left bottom;
    }
  }
  .category-icon {
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    cursor: auto;
    background: $primary-gradient;
  }
  .photo-caption {
    font-size: 0.8rem;
    text-align: center;
    top: 0;
    width: 100%;
    max-width: 100%;
    font-weight: 400;
    color: #a9a9a9;
    margin-top: 0.2rem;
  }
  .header-right {
    flex-direction: column;
    justify-content: space-between;
    margin-top: 0.25rem;
    width: 100%;
    max-width: 100%;
    @include mobile {
      width: 100%;
      height: 100%;
      padding: 0 0.5rem;
      align-content: center;
      justify-content: center;
      margin-top: 0.25rem;
    }
  }
  .project-creator {
    position: relative;
    align-items: center;
    font-size: 0.65rem;
    flex-grow: 1;
    max-width: 100%;
    @include mobile {
      align-items: flex-start;
      flex-grow: 0;
      width: 50%;
      justify-content: center;
    }
  }
  .owner {
    align-items: center;
    justify-content: center;
    @include mobile {
      min-height: 30px;
    }
  }
  .owner-name {
    font-size: 0.8rem;
    font-weight: 400;
    color: #4a4a4a;
    @include mini-mobile {
      font-size: 0.65rem;
      width: 5.5rem;
      display: inline-block;
    }
  }
  .owner-icon {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.5rem;
    img {
      background-color: $grey-lighter;
      border-radius: 50%;
      border: 1px solid whitesmoke;
      height: 100%;
      width: 100%;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .meta-counts {
    max-width: 100%;
    flex-grow: 1;
    @include mobile{
      width: 50%;
      justify-content: space-around !important;
    }
  }
  .top-right{
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.6rem;
    margin-bottom: 0.5rem;
    @include mobile {
      justify-content: space-between;
      margin-top: 0.3rem;
      margin-right: auto;
    }
  }
  .project-description {
    font-size: 0.8rem;
    margin-bottom: 0rem;
    margin-top: 1rem;
    color: black;
    p:first-child {
      color: green!important;
    }
    @include mobile {
      width: 100%;
      left: 0;
    }
  }
  .share-btn {
    margin-left: 0.75rem;
    position: relative;
    @include mobile {
      padding-left: 0.5rem;
      right: 0rem;
    }
  }
  .project-photo-modal {
    .modal-content {
      margin: 0;
    }
    .modal-close {
      position: absolute;
    }
  }
  .breadcrumb {
    font-size: 0.9rem;
    width: 100%;
    margin: 1rem 0.5rem;
    left: 0;
    .icon {
      margin-top: 0.2rem;
      margin-right: 0;
      color: $primary;
      font-size: 0.85rem;
    }
    .breadcrumb-item {
      color: #7a7a7a;
    }
    .breadcrumb-item:hover {
      color: $primary;
    }
     @include mobile {
       margin-left: 1rem;
     }
  }
  .admin-breadcrumb {
    margin-top: 1.5rem;
  }
  .listen-txt-btn {
    display: inline-block;
    white-space: nowrap;
    color: $primary;
    margin: 0;
    padding-left: 0.5rem;
    cursor: pointer;
  }
  .audio-player {
    align-items: center;
    justify-content: center;
  }
  .dot {
    height: 40px;
    width: 40px;
    background-color: #F1F3F4;
    border-radius: 50%;
    border: 2px solid $primary;
    display: inline-block;
  }
  .play-button {
    padding-left: 0.25rem;
    color: $primary;
  }
  audio {
    height: 2.75rem;
    @include mobile {
      width: 250px;
    }
  }
  .edge-audio-btn {
    border-radius: 15px;
    border: #393939;
    background-size: 150% 150%;
    background: #393939;
  }
  .fixed-position {
    padding-top: 0.5rem;
    padding-right: 2rem;
    position: fixed;
    bottom: 50px;
    left: 60px;
    z-index: 10;
    display: flex;
    justify-content: flex-end;
    @media (max-width: 1340px) {
      right: 0;
      left: auto;
    }
    @include mobile-and-ipad {
      bottom: 28px;
      padding-right: 1rem;
    }
}

.audio-background{
  @include tablet {
    padding: 0.5rem 0.75rem;
    border-radius: 25px;
    background: rgba(255, 255, 255,0.9);
  }

  @include mobile {
    padding: 0.5rem 0.75rem;
    border-radius: 10px;
    background: rgba(255, 255, 255,0.9);
    width: 192px;
  }
}

.audio-container{
  flex-grow: 1;
  @include touch{
    flex-grow: 0;
    padding: 1.25rem 0;
  }
  @include mobile{
    width: 100%;
    justify-content: center;
  }
}

  .resource-title {
    font-family:    'Noto Serif JP, Serif';
    font-size:      18px;
    font-weight:    bold;
    text-transform: uppercase;
    margin: 0 auto;
    color: #7a2a90;
    padding-bottom: 5px;
    border-bottom: 1px solid #7a2a90;
  }

  // PERSONALIZE BUTTON STYLES

  .personalize-button-container {
    display: flex;
    justify-content: center;
    margin: 2rem 0;
  }

  .title {
    padding: 1.3rem 0;
    margin-top: 0px;
    font-family: 'Noto Serif JP, Serif';
    font-weight: normal;
    h2 {
      font-family: 'Noto Serif JP, Serif';
      font-weight: $primary-font-weight;
      font-size: 1.5rem;
    }
  }

  .resource-date {
    font-family: 'Noto Serif JP, Serif';
    font-weight: normal;
    margin: auto;
  }

  .resource-image {
    margin-top: 5px;
  }
</style>
